import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

export function querySuggestionTemplate({ item, components }) {
  return html`
    <a href="/search?q=${encodeURIComponent(item.query)}" class="ac-suggestion">
      <${components.Highlight} hit=${item} attribute="query" tagName="strong" />
    </a>
  `;
}